import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { ar } from "./common/ar";
import { en } from "./common/en";

const resources = {
	en: {
		translation: en,
	},
	ar: {
		translation: ar,
	},
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: "ar",
		interpolation: {
			escapeValue: false, // React already safes from xss
		},
	});

export default i18n;
